
import { defineComponent, PropType } from "vue";

interface FaqItem {
  pregunta: string;
  respuesta: string;
}

export default defineComponent({
  name: "faqs-content",
  props: {
    faqsCursos: {
      type: Array as PropType<FaqItem[]>,
      default: () => [],
    },
    faqsIam: {
      type: Array as PropType<FaqItem[]>,
      default: () => [],
    },
  },
});
